// Tooltip de livros em construção no avatar do header (.cda-uc-tip).
//
// Abre sozinho ao carregar a página. O X (ou Esc, ou abrir o dropdown da conta) fecha
// e grava o horário no cookie `cda_uc_tip_closed_at`; depois de 2 minutos ele reabre,
// inclusive em outra página (o servidor manda o tooltip escondido enquanto o prazo corre
// e aqui agendamos a reabertura pelo tempo que falta).
//
// No desktop, quando abre sozinho, fecha sozinho depois de AUTO_CLOSE_MS (como se fosse o X);
// com o mouse em cima ou o foco dentro dele, espera a pessoa sair.

var COOKIE_NAME = 'cda_uc_tip_closed_at';
var SNOOZE_MS = 2 * 60 * 1000;
var RETRY_MS = 3000;
var AUTO_CLOSE_MS = 3000;
var timer = null;
var autoCloseTimer = null;

function tips() {
  return document.querySelectorAll('[data-cda-uc-tip]');
}

function isVisible() {
  return Array.prototype.some.call(tips(), function(tip) { return !tip.hidden; });
}

function accountMenuOpen() {
  return !!document.querySelector('[data-cda-account-menu]:not([hidden])');
}

function closedAt() {
  var match = document.cookie.match(/(?:^|;\s*)cda_uc_tip_closed_at=(\d+)/);
  return match ? Number(match[1]) : 0;
}

// só o do desktop, e só se estiver aparecendo (no celular ele fica escondido pelo CSS)
function scheduleAutoClose() {
  window.clearTimeout(autoCloseTimer);
  autoCloseTimer = null;

  var tip = document.querySelector('.cda-uc-tip--desktop[data-cda-uc-tip]');
  if (!tip || tip.hidden || !tip.getClientRects().length) return;

  autoCloseTimer = window.setTimeout(function() {
    autoCloseTimer = null;
    if (tip.matches(':hover') || tip.contains(document.activeElement)) {
      scheduleAutoClose();
      return;
    }
    close();
  }, AUTO_CLOSE_MS);
}

function schedule(ms) {
  window.clearTimeout(timer);
  timer = window.setTimeout(show, Math.max(ms, 0));
}

function show() {
  timer = null;
  // com o dropdown da conta aberto o aviso já está lá; tenta de novo daqui a pouco
  if (accountMenuOpen()) {
    schedule(RETRY_MS);
    return;
  }

  Array.prototype.forEach.call(tips(), function(tip) {
    tip.classList.remove('is-leaving');
    tip.hidden = false;
  });

  scheduleAutoClose();
}

function close() {
  window.clearTimeout(autoCloseTimer);
  autoCloseTimer = null;
  if (!isVisible()) return;

  document.cookie = COOKIE_NAME + '=' + Date.now() + '; path=/; SameSite=Lax';

  Array.prototype.forEach.call(tips(), function(tip) {
    tip.classList.add('is-leaving');
    window.setTimeout(function() {
      tip.hidden = true;
      tip.classList.remove('is-leaving');
    }, 180);
  });

  schedule(SNOOZE_MS);
}

// Listeners globais, registrados uma vez (o document sobrevive às visitas do Turbolinks).
document.addEventListener('click', function(event) {
  if (event.target.closest('[data-cda-uc-tip-dismiss]')) close();
});

document.addEventListener('keydown', function(event) {
  if ((event.key === 'Escape' || event.key === 'Esc') && isVisible()) close();
});

document.addEventListener('cda:account-menu-open', close);

document.addEventListener('turbolinks:load', function() {
  window.clearTimeout(timer);
  timer = null;
  window.clearTimeout(autoCloseTimer);
  autoCloseTimer = null;

  var list = tips();
  if (!list.length) return;

  // Veio escondido do servidor: reabre quando os 2 minutos terminarem.
  if (list[0].hidden) schedule(SNOOZE_MS - (Date.now() - closedAt()));
  // Veio aberto: no desktop fecha sozinho.
  else scheduleAutoClose();
});
